







































































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import { ItemDTO, LookFullDTO } from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import VImage from '@/components/common/VImage.vue';
import { looksModule, thingsModule, clientsModule } from '@/store';
import LooksItem from '@/components/looks/LooksItem.vue';
import CheckCard from '@/components/common/CheckCard.vue';
import AddLook from '@/components/looks/AddLook.vue';
import LookActionsCard from '@/components/looks/LookActionsCard.vue';
import { Route } from 'vue-router';
import { set } from 'date-fns';

@Component({
  name: 'looks-edit-page',
  components: {
    EditingLayout,
    LooksItem,
    AddLook,
    LookActionsCard,
    VImage,
    CheckCard,
  },
})
export default class Catalog extends Vue {
  pickerOptions = {
    disabledDate: (date: Date) => !this.shoppingDays.includes(set(date || 0, {
      hours: 0, minutes: 0, seconds: 0, milliseconds: 0,
    }).valueOf()),
  }

  get client() {
    return clientsModule.model;
  }

  get looks() {
    return looksModule.groupedThingsByLook;
  }

  get look() {
    return looksModule.selectedLook;
  }

  get things() {
    return thingsModule.list;
  }

  get lookThings() {
    return this.look && this.look.items ? this.look.items : [];
  }

  get selectedThings() {
    return this.lookThings.map(thing => thing.clientItemId);
  }

  get categories() {
    return this.groupByCategory.map(group => group.name);
  }

  get groupByCategory() {
    return thingsModule.groupByCategory;
  }

  get loadingThing() {
    return looksModule.loadingThing;
  }

  get dateFilter() {
    return thingsModule.dateFilter;
  }

  set dateFilter(date: number | null) {
    thingsModule.setDateFilter(date);
  }

  get shoppingDays() {
    return thingsModule.shoppingDays;
  }

  created() {
    amplitude.getInstance().logEvent(`Открыта страница пользователя ${this.client && this.client.id}`);
    if (this.client && this.client.id != null) {
      looksModule.fetchLooks({ userId: this.client.id, status: 'REAL' }).then(() => {
        if (this.$route.query.selected) {
          looksModule.setSelected([Number(this.$route.query.selected)]);
          this.$nextTick().then(() => {
            this.scrollIntoView(Number(this.$route.query.selected));
          });
        }
      });
      thingsModule.fetchThings(this.client.id);
      if (this.client && this.client.id != null) {
        looksModule.fetchCategories(this.client.id);
      }
    }
  }

  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    looksModule.setSelected([Number(to.query.selected)]);
    next();
  }

  selectLook(id: number | null) {
    if (id !== Number(this.$route.query.selected)) {
      this.$router.push({ query: { selected: id ? String(id) : null } });
    }
  }

  scrollIntoView(id: number) {
    if (Array.isArray(this.$refs.actionCards)) {
      const element = this.$refs.actionCards[this.looks.findIndex(look => look.id === id)];
      if (!(element instanceof Element)) {
        element.$el.scrollIntoView({ block: 'center' });
      }
    }
  }

  async copyLook(look: LookFullDTO) {
    const { id } = await looksModule.copyLook(look);
    if (id) {
      this.selectLook(id);
      this.scrollIntoView(id);
    }
  }

  removeLook(id: number) {
    this.$confirm('Вы уверены, что хотите удалить данный образ?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      looksModule.deleteLook([id]);
      if (id === Number(this.$route.query.selected)) {
        this.selectLook(null);
      }
      this.$message({
        type: 'success',
        message: 'Образ удалён',
      });
    });
  }

  addLookThing(thing: ItemDTO) {
    if (this.look && this.look.id && !this.loadingThing) {
      looksModule.saveLookThing({ lookId: this.look.id, thing });
    }
  }

  removeLookThing(thing: ItemDTO) {
    if (this.look && this.look.id && thing.id && !this.loadingThing) {
      looksModule.deleteLookThing({ lookId: this.look.id, thingId: thing.id });
    }
  }

  isSelected(id: number) {
    return this.selectedThings.includes(id);
  }

  thingImg(item: ItemDTO) {
    return item.fileNames && item.fileNames.length ? item.fileNames[0].fileName : null;
  }
}
